<template>
  <modal v-model="isActive">
    <div class="modal-content">
      <p class="text-lg text-center" v-html="message"></p>
    </div>
    <div class="modal-button flex justify-center">
      <a @click="ok" class="button-primary block w-2/4">OK</a>
    </div>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"

export default {
  components: {
    Modal
  },
  props: {
    message: {
      type: String,
      default: function () {
        return undefined
      }
    },
    success: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  created () {
    const el = document.createElement('div');
    document.getElementsByTagName('body')[0].appendChild(el);
    this.$mount(el);
    this.isActive = true;
  },
  methods: {
    ok: function () {
      this.success();
      this.destroy();
    },
    destroy: function () {
      this.isActive = false;
      // 即座にdomを削除するとtransitionする前に消えてしまうので、200ms待つ
      setTimeout(() => {
        this.$el.parentNode.removeChild(this.$el);
        this.$destroy();
      }, 200);
    }
  }
}
</script>
